import React, { useEffect } from "react";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import "./AddUser.css";
import { useForm } from "react-hook-form";
import Input from "../../../Components/InputComponent/Input";
import ButtonComponent from "../../../Components/ButtonComponent/ButtonComponent";
import { postApi } from "../../../Api/Api";
import toast from "react-hot-toast";
import { USER_ROUTE } from "../../../Api/Routes";
import { parseError } from "../../../utils/helpers";

const AddUser = (props) => {
  const { handleClose, open, userId, AddUpdateUser, selectedUser } = props;

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (userId) {
      const fetchUserDetails = async () => {
        try {
          const userDetails = selectedUser;
          setValue("title", userDetails.title);
          setValue("first_name", userDetails.first_name);
          setValue("middle_name", userDetails.middle_name);
          setValue("last_name", userDetails.last_name);
          setValue("phone_no", userDetails.phone_no);
          setValue("email", userDetails.email);
          setValue("role", userDetails.role);
        } catch (error) {
          console.error("Error fetching user details:", error);
        }
      };

      fetchUserDetails();
    }
  }, [setValue, userId, selectedUser]);

  const onSubmit = async (formData, event) => {
    event.preventDefault();
    const endpoint = userId ? `${USER_ROUTE}/${userId}` : USER_ROUTE;

    formData.role = "Admin";

    try {
      const responseData = await postApi(
        endpoint,
        userId ? { ...formData, id: userId } : formData
      );

      if (responseData.data) {
        toast.success(userId ? "User Updated" : "User Added");
        reset();
        handleClose();
        AddUpdateUser();
      } else {
        let message = userId ? "User Updated Failed" : "Add User Failed";
        const err = parseError(responseData);
        if (err) {
          message += `: ${err}`;
        }
        toast.error(message);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <Box>
      <Modal
        open={open}
        onClose={handleClose}
        className="profile-modal"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className="modal-shadow">
            <Box className="modal-header">
              <Typography
                id="modal-modal-title"
                className="text-primery"
                variant="h4"
                component="h4"
              >
                {userId ? "Update User" : "Add User"}
              </Typography>
              <Button onClick={handleClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    opacity="0.2"
                    d="M32.0002 3.138L28.8632 0L16.4242 12.439L3.98517 0L0.847168 3.138L13.2862 15.577L0.847168 28.016L3.98517 31.154L16.4242 18.714L28.8632 31.153L32.0012 28.015L19.5612 15.577L32.0002 3.138Z"
                    fill="white"
                  />
                </svg>
              </Button>
            </Box>
            <Box
              className="modal-body"
              id="modal-modal-description"
              component="form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className="form-group">
                      <Input
                        label="Title"
                        placeholder="Mr / Ms"
                        type="text"
                        name="title"
                        requiredField="requiredField"
                        register={register}
                        validationRules={{
                          required: "Title is required",
                        }}
                      />
                      {errors.title && (
                        <p className="error-message">{errors.title.message}</p>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className="form-group">
                      <Input
                        label="First Name"
                        placeholder="Lindsey"
                        type="text"
                        name="first_name"
                        register={register}
                      />
                      {errors.first_name && (
                        <p className="error-message">
                          {errors.first_name.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className="form-group">
                      <Input
                        label="Middle Name"
                        placeholder="Daniel"
                        type="text"
                        name="middle_name"
                        register={register}
                      />
                      {errors.middle_name && (
                        <p className="error-message">
                          {errors.middle_name.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className="form-group">
                      <Input
                        label="Last Name"
                        placeholder="Thomas"
                        type="text"
                        name="last_name"
                        requiredField="requiredField"
                        register={register}
                        validationRules={{
                          required: "Last Name is required",
                        }}
                      />
                      {errors.last_name && (
                        <p className="error-message">
                          {errors.last_name.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className="form-group">
                      <Input
                        label="Phone Number"
                        placeholder="963214587"
                        type="text"
                        name="phone_no"
                        register={register}
                      />
                      {errors.phone_no && (
                        <p className="error-message">
                          {errors.phone_no.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className="form-group">
                      <Input
                        label="Email"
                        placeholder="apollo@gmail.com"
                        type="email"
                        name="email"
                        requiredField="requiredField"
                        register={register}
                        validationRules={{
                          required: "Email is required",
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message: "Please enter a valid email address",
                          },
                        }}
                      />
                      {errors.email && (
                        <p className="error-message">{errors.email.message}</p>
                      )}
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Box className="form-group">
                      <Box className="btn-center">
                        <ButtonComponent
                          type="submit"
                          buttonText={userId ? "Update User" : "Add User"}
                          buttonVariant="contained"
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AddUser;

const style = {
  position: "absolute",
  top: "50%",
  left: 15,
  right: 15,
  transform: "translateY(-50%)",
  maxWidth: 1000,
  color: "#ffffff",
  boxShadow: 24,
  margin: "1rem auto",
  maxHeight: "100%",
};
